import { AppProviderContextType } from ".";

import React from "react";

export const AppContext = React.createContext<AppProviderContextType>({} as AppProviderContextType)